import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-evo-close-button',
  templateUrl: './evo-close-button.component.html',
  styleUrls: ['./evo-close-button.component.css']
})
export class EvoCloseButtonComponent implements OnInit {

  @Output() clicked = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  onClicked() {
    this.clicked.emit();
  }

}
